var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightning(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.752 27.083L15.7 39.395 27.6 22.917H16.248L18.3 10.605 6.399 27.083h11.353zm6.12-24.563C24.234.348 21.417-.828 20.128.958L.636 27.947C-.36 29.325.625 31.25 2.324 31.25h10.51l-2.706 16.23c-.362 2.172 2.455 3.348 3.744 1.562l19.492-26.989c.995-1.378.011-3.303-1.688-3.303h-10.51l2.706-16.23z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCAzNCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43NTE5IDI3LjA4MzNMMTUuNjk5OSAzOS4zOTVMMjcuNjAxIDIyLjkxNjdIMTYuMjQ4MUwxOC4zIDEwLjYwNDlMNi4zOTg5NSAyNy4wODMzSDE3Ljc1MTlaTTIzLjg3MTYgMi41MTk5NkMyNC4yMzM3IDAuMzQ3Nzk3IDIxLjQxNzEgLTAuODI3NTI2IDIwLjEyNzcgMC45NTc2OTJMMC42MzU1NDMgMjcuOTQ2OUMtMC4zNTk1MDkgMjkuMzI0NiAwLjYyNDk0MSAzMS4yNSAyLjMyNDQ2IDMxLjI1SDEyLjgzMzNMMTAuMTI4MyA0Ny40OEM5Ljc2NjI3IDQ5LjY1MjIgMTIuNTgyOSA1MC44Mjc1IDEzLjg3MjIgNDkuMDQyM0wzMy4zNjQ0IDIyLjA1MzFDMzQuMzU5NCAyMC42NzUzIDMzLjM3NSAxOC43NSAzMS42NzU1IDE4Ljc1SDIxLjE2NjZMMjMuODcxNiAyLjUxOTk2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };